import { BannerDottedGroup } from ".";
import { useBanner, bannerInlineStyleBodyDottedGroups } from "../../..";

var BannerDottedGroupList = function BannerDottedGroupList() {
  var banner = useBanner();
  var groups = banner.groups,
      showGroups = banner.decision.showGroups;
  return showGroups ? h("div", bannerInlineStyleBodyDottedGroups(banner), groups.filter(function (_ref) {
    var items = _ref.items;
    return !!items.length;
  }).map(function (group) {
    return h(BannerDottedGroup, {
      key: group.id,
      group: group
    });
  })) : null;
};

export { BannerDottedGroupList };